/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { BaseUUID, BaseMetaColumn, FilterItem, SortItem } from "namirasoft-core";
import { NSBaseMetaDatabase, NSBaseMetaTable } from "namirasoft-site";
import { NamirasoftPaymentServer } from "../NamirasoftPaymentServer";
import { OfferItemRow } from "../row/OfferItemRow";

export class OfferItemMetaTable extends NSBaseMetaTable<NamirasoftPaymentServer, OfferItemRow>
{
    public override columns: {
        id: BaseMetaColumn;
        product_id: BaseMetaColumn;
        sales_item_id: BaseMetaColumn;
        offer_id: BaseMetaColumn;
        name: BaseMetaColumn;
        logo: BaseMetaColumn;
        order: BaseMetaColumn;
        dominant: BaseMetaColumn;
        consumable: BaseMetaColumn;
        consumable_asset_id: BaseMetaColumn;
        expire_value: BaseMetaColumn;
        expire_unit: BaseMetaColumn;
        type: BaseMetaColumn;
        one_off_model: BaseMetaColumn;
        one_off_flat_amount: BaseMetaColumn;
        one_off_package_amount: BaseMetaColumn;
        one_off_package_ceiling_value: BaseMetaColumn;
        one_off_package_ceiling_unit: BaseMetaColumn;
        one_off_choosable_on_gateway: BaseMetaColumn;
        one_off_choosable_suggested_amount: BaseMetaColumn;
        one_off_choosable_limit_min: BaseMetaColumn;
        one_off_choosable_limit_max: BaseMetaColumn;
        recurring_model: BaseMetaColumn;
        recurring_duration_value: BaseMetaColumn;
        recurring_duration_unit: BaseMetaColumn;
        recurring_flat_amount: BaseMetaColumn;
        recurring_package_amount: BaseMetaColumn;
        recurring_package_ceiling_value: BaseMetaColumn;
        recurring_package_ceiling_unit: BaseMetaColumn;
        recurring_tiered_type: BaseMetaColumn;
        recurring_tiered_amounts: BaseMetaColumn;
        recurring_usage_type: BaseMetaColumn;
        recurring_usage_name: BaseMetaColumn;
        recurring_usage_duration: BaseMetaColumn;
        recurring_usage_meter_event_name: BaseMetaColumn;
        recurring_usage_unit_amount: BaseMetaColumn;
        recurring_usage_package_amount: BaseMetaColumn;
        recurring_usage_package_ceiling_value: BaseMetaColumn;
        recurring_usage_package_ceiling_unit: BaseMetaColumn;
        recurring_usage_tiered_type: BaseMetaColumn;
        recurring_usage_tiered_amounts: BaseMetaColumn;
        currency: BaseMetaColumn;
        was_price: BaseMetaColumn;
        description: BaseMetaColumn;
        created_at: BaseMetaColumn;
        updated_at: BaseMetaColumn;
    }
    constructor(database: NSBaseMetaDatabase<NamirasoftPaymentServer>)
    {
        super(database, "offer_item", "Offer Item", new BaseUUID("pym-ofr-itm"));
        this.columns = {
            id: new BaseMetaColumn(this, "id", "ID", "String", true),
            product_id: new BaseMetaColumn(this, "product_id", "Product ID", "String", true),
            sales_item_id: new BaseMetaColumn(this, "sales_item_id", "Sales Item ID", "String", true),
            offer_id: new BaseMetaColumn(this, "offer_id", "Offer ID", "String", true),
            name: new BaseMetaColumn(this, "name", "Name", "String", true),
            logo: new BaseMetaColumn(this, "logo", "Logo", "String", false),
            order: new BaseMetaColumn(this, "order", "Order", "Integer", true),
            dominant: new BaseMetaColumn(this, "dominant", "Dominant", "Boolean", true),
            consumable: new BaseMetaColumn(this, "consumable", "Consumable", "Boolean", true),
            consumable_asset_id: new BaseMetaColumn(this, "consumable_asset_id", "Consumable Asset ID", "String", false),
            expire_value: new BaseMetaColumn(this, "expire_value", "Expire Value", "Integer", false),
            expire_unit: new BaseMetaColumn(this, "expire_unit", "Expire Unit", "Enum", false),
            type: new BaseMetaColumn(this, "type", "Type", "Enum", true),
            one_off_model: new BaseMetaColumn(this, "one_off_model", "One Off Model", "Enum", false),
            one_off_flat_amount: new BaseMetaColumn(this, "one_off_flat_amount", "One Off Flat Amount", "Integer", false),
            one_off_package_amount: new BaseMetaColumn(this, "one_off_package_amount", "One Off Package Amount", "Integer", false),
            one_off_package_ceiling_value: new BaseMetaColumn(this, "one_off_package_ceiling_value", "One Off Package Ceiling Value", "Integer", false),
            one_off_package_ceiling_unit: new BaseMetaColumn(this, "one_off_package_ceiling_unit", "One Off Package Ceiling Unit", "String", false),
            one_off_choosable_on_gateway: new BaseMetaColumn(this, "one_off_choosable_on_gateway", "One Off Choosable On Gateway", "Boolean", false),
            one_off_choosable_suggested_amount: new BaseMetaColumn(this, "one_off_choosable_suggested_amount", "One Off Choosable Suggested Amount", "Integer", false),
            one_off_choosable_limit_min: new BaseMetaColumn(this, "one_off_choosable_limit_min", "One Off Choosable Limit Min", "Integer", false),
            one_off_choosable_limit_max: new BaseMetaColumn(this, "one_off_choosable_limit_max", "One Off Choosable Limit Max", "Integer", false),
            recurring_model: new BaseMetaColumn(this, "recurring_model", "Recurring Model", "Enum", false),
            recurring_duration_value: new BaseMetaColumn(this, "recurring_duration_value", "Recurring Duration Value", "Integer", false),
            recurring_duration_unit: new BaseMetaColumn(this, "recurring_duration_unit", "Recurring Duration Unit", "Enum", false),
            recurring_flat_amount: new BaseMetaColumn(this, "recurring_flat_amount", "Recurring Flat Amount", "Integer", false),
            recurring_package_amount: new BaseMetaColumn(this, "recurring_package_amount", "Recurring Package Amount", "Integer", false),
            recurring_package_ceiling_value: new BaseMetaColumn(this, "recurring_package_ceiling_value", "Recurring Package Ceiling Value", "Integer", false),
            recurring_package_ceiling_unit: new BaseMetaColumn(this, "recurring_package_ceiling_unit", "Recurring Package Ceiling Unit", "String", false),
            recurring_tiered_type: new BaseMetaColumn(this, "recurring_tiered_type", "Recurring Tiered Type", "Enum", false),
            recurring_tiered_amounts: new BaseMetaColumn(this, "recurring_tiered_amounts", "Recurring Tiered Amounts", "Any", false),
            recurring_usage_type: new BaseMetaColumn(this, "recurring_usage_type", "Recurring Usage Type", "Enum", false),
            recurring_usage_name: new BaseMetaColumn(this, "recurring_usage_name", "Recurring Usage Name", "String", false),
            recurring_usage_duration: new BaseMetaColumn(this, "recurring_usage_duration", "Recurring Usage Duration", "String", false),
            recurring_usage_meter_event_name: new BaseMetaColumn(this, "recurring_usage_meter_event_name", "Recurring Usage Meter Event Name", "String", false),
            recurring_usage_unit_amount: new BaseMetaColumn(this, "recurring_usage_unit_amount", "Recurring Usage Unit Amount", "Integer", false),
            recurring_usage_package_amount: new BaseMetaColumn(this, "recurring_usage_package_amount", "Recurring Usage Package Amount", "Integer", false),
            recurring_usage_package_ceiling_value: new BaseMetaColumn(this, "recurring_usage_package_ceiling_value", "Recurring Usage Package Ceiling Value", "Integer", false),
            recurring_usage_package_ceiling_unit: new BaseMetaColumn(this, "recurring_usage_package_ceiling_unit", "Recurring Usage Package Ceiling Unit", "String", false),
            recurring_usage_tiered_type: new BaseMetaColumn(this, "recurring_usage_tiered_type", "Recurring Usage Tiered Type", "Enum", false),
            recurring_usage_tiered_amounts: new BaseMetaColumn(this, "recurring_usage_tiered_amounts", "Recurring Usage Tiered Amounts", "Any", false),
            currency: new BaseMetaColumn(this, "currency", "Currency", "String", true),
            was_price: new BaseMetaColumn(this, "was_price", "Was Price", "String", false),
            description: new BaseMetaColumn(this, "description", "Description", "String", true),
            created_at: new BaseMetaColumn(this, "created_at", "Created At", "DateTime", true),
            updated_at: new BaseMetaColumn(this, "updated_at", "Updated At", "DateTime", true),
        };
        this.back_end.get = async (id: string) =>
        {
            console.log(id);
            throw new Error("OfferItem.Get is not implemented");
        };
        this.back_end.list = async (filters: FilterItem[] | null, page: (number | null), size: (number | null), sorts: SortItem[]) =>
        {
            console.log(filters, page, size, sorts);
            throw new Error("OfferItem.List is not implemented");
        };
    }
};